(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["turf-pro-estimate-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeEstimator = () => {
      const form = document.getElementById('TurfProEstimateForm');
      if (!form || form.dataset.ready === 'true') return;
      form.dataset.ready = 'true';

      const sqft = form.querySelector('#TurfProSqft');
      const total = form.querySelector('#TurfProEstimateTotal');
      const estimateHidden = form.querySelector('#TurfProEstimateHidden');
      const rateHidden = form.querySelector('#TurfProRateHidden');
      const date = form.querySelector('#TurfProDate');
      const rateInputs = [...form.querySelectorAll('[data-rate]')];
      const wasteInputs = [...form.querySelectorAll('[data-waste]')];
      const planInputs = [...form.querySelectorAll('[data-plan]')];
      const planHidden = form.querySelector('#TurfProPlanHidden');
      const frequencyInputs = [...form.querySelectorAll('[data-frequency]')];
      const payNow = form.querySelector('#TurfProPayNow');
      const checkoutStatus = form.querySelector('#TurfProCheckoutStatus');

      const checkoutVariants = {
        'one-time': {
          'no-pets': { monthly: { id: 53448256291125, price: 4.90 } },
          pets: { monthly: { id: 53448256323893, price: 7.90 } }
        },
        '3-month': {
          'no-pets': {
            monthly: { id: 53448250425653, price: 13.97 },
            'every-2-months': { id: 53448250491189, price: 9.31 },
            quarterly: { id: 53448250556725, price: 4.66 }
          },
          pets: {
            monthly: { id: 53448250458421, price: 22.52 },
            'every-2-months': { id: 53448250523957, price: 15.01 },
            quarterly: { id: 53448250589493, price: 7.51 }
          }
        },
        '6-month': {
          'no-pets': {
            monthly: { id: 53448251343157, price: 27.05 },
            'every-2-months': { id: 53448251408693, price: 13.52 },
            quarterly: { id: 53448251474229, price: 9.02 }
          },
          pets: {
            monthly: { id: 53448251375925, price: 43.61 },
            'every-2-months': { id: 53448251441461, price: 21.80 },
            quarterly: { id: 53448251506997, price: 14.54 }
          }
        },
        '1-year': {
          'no-pets': {
            monthly: { id: 53448248656181, price: 51.74 },
            'every-2-months': { id: 53448248721717, price: 25.87 },
            quarterly: { id: 53448248787253, price: 17.25 }
          },
          pets: {
            monthly: { id: 53448248688949, price: 83.42 },
            'every-2-months': { id: 53448248754485, price: 41.71 },
            quarterly: { id: 53448248820021, price: 27.81 }
          }
        },
        '2-year': {
          'no-pets': {
            monthly: { id: 53448247738677, price: 99.96 },
            'every-2-months': { id: 53448247804213, price: 49.98 },
            quarterly: { id: 53448247869749, price: 33.32 }
          },
          pets: {
            monthly: { id: 53448247771445, price: 161.16 },
            'every-2-months': { id: 53448247836981, price: 80.58 },
            quarterly: { id: 53448247902517, price: 53.72 }
          }
        },
        lifetime: {
          'no-pets': {
            monthly: { id: 53448249508149, price: 149.94 },
            'every-2-months': { id: 53448249573685, price: 74.97 },
            quarterly: { id: 53448249639221, price: 49.98 }
          },
          pets: {
            monthly: { id: 53448249540917, price: 241.74 },
            'every-2-months': { id: 53448249606453, price: 120.87 },
            quarterly: { id: 53448249671989, price: 80.58 }
          }
        }
      };

      const minimumVariants = {
        'one-time': { monthly: { id: 53448478753077, price: 100.00 } },
        '3-month': {
          monthly: { id: 53448478785845, price: 285.00 },
          'every-2-months': { id: 53448478818613, price: 190.00 },
          quarterly: { id: 53448478851381, price: 100.00 }
        },
        '6-month': {
          monthly: { id: 53448478884149, price: 552.00 },
          'every-2-months': { id: 53448478916917, price: 276.00 },
          quarterly: { id: 53448478949685, price: 184.00 }
        },
        '1-year': {
          monthly: { id: 53448478982453, price: 1056.00 },
          'every-2-months': { id: 53448479015221, price: 528.00 },
          quarterly: { id: 53448479047989, price: 352.00 }
        },
        '2-year': {
          monthly: { id: 53448479080757, price: 2040.00 },
          'every-2-months': { id: 53448479113525, price: 1020.00 },
          quarterly: { id: 53448479146293, price: 680.00 }
        },
        lifetime: {
          monthly: { id: 53448479179061, price: 3060.00 },
          'every-2-months': { id: 53448479211829, price: 1530.00 },
          quarterly: { id: 53448479244597, price: 1020.00 }
        }
      };

      const localToday = new Date();
      localToday.setMinutes(localToday.getMinutes() - localToday.getTimezoneOffset());
      date.min = localToday.toISOString().slice(0, 10);

      const calculate = () => {
        const area = Number(sqft.value || 0);
        const selectedRate = rateInputs.find((input) => input.checked);
        const selectedWaste = wasteInputs.find((input) => input.checked);
        const selectedPlan = planInputs.find((input) => input.checked);
        const selectedFrequency = frequencyInputs.find((input) => input.checked);
        if (!area || !selectedRate) {
          total.textContent = total.dataset.emptyMessage;
          estimateHidden.value = 'Not calculated';
          rateHidden.value = 'Not selected';
          payNow.disabled = true;
          return;
        }
        const rate = Number(selectedRate.dataset.rate);
        const waste = Number(selectedWaste?.dataset.waste || 0);
        const planKey = selectedPlan?.dataset.plan || 'one-time';
        const frequencyKey = planKey === 'one-time' ? 'monthly' : (selectedFrequency?.dataset.frequency || 'monthly');
        const months = Number(selectedPlan?.dataset.months || 0);
        const interval = Number(selectedFrequency?.dataset.interval || 1);
        const visits = planKey === 'one-time' ? 1 : Math.ceil(months / interval);
        const discount = Number(selectedPlan?.dataset.discount || 0);
        const turfUseKey = rate === 0.79 ? 'pets' : 'no-pets';
        const units = Math.ceil(area / 10);
        const billedArea = units * 10;
        const standardPerVisit = billedArea * rate;
        const minimumApplies = standardPerVisit < 100;
        const variant = minimumApplies
          ? minimumVariants[planKey]?.[frequencyKey]
          : checkoutVariants[planKey]?.[turfUseKey]?.[frequencyKey];
        const checkoutQuantity = minimumApplies ? 1 : units;
        const discountedService = Number(variant?.price || 0) * checkoutQuantity;
        const wasteTotal = waste * visits;
        const result = discountedService + wasteTotal;
        total.textContent = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(result);
        const planName = selectedPlan?.value || 'One-time cleaning';
        const pricingBasis = minimumApplies ? '100.00 USD minimum service charge per visit' : `${billedArea} billable sq. ft.`;
        estimateHidden.value = `${result.toFixed(2)} USD based on ${pricingBasis}, ${visits} visit(s), ${(discount * 100).toFixed(0)}% service savings, including ${wasteTotal.toFixed(2)} USD total waste fees`;
        rateHidden.value = `${rate.toFixed(2)} USD per sq. ft.`;
        planHidden.value = planName;
        payNow.disabled = !variant;
        payNow.dataset.variantId = variant?.id || '';
        payNow.dataset.units = String(checkoutQuantity);
        payNow.dataset.visits = String(visits);
        payNow.dataset.billedArea = String(billedArea);
        payNow.dataset.planName = planName;
        payNow.dataset.frequency = selectedFrequency?.value || 'One-time';
        payNow.dataset.includeWaste = waste > 0 ? 'true' : 'false';
        payNow.dataset.minimumApplied = minimumApplies ? 'true' : 'false';
      };

      const validateDate = () => {
        if (!date.value) return;
        const selected = new Date(`${date.value}T12:00:00`);
        date.setCustomValidity(selected.getDay() === 0 ? date.dataset.sundayMessage : '');
      };

      sqft.addEventListener('input', calculate);
      rateInputs.forEach((input) => input.addEventListener('change', calculate));
      wasteInputs.forEach((input) => input.addEventListener('change', calculate));
      planInputs.forEach((input) => input.addEventListener('change', calculate));
      frequencyInputs.forEach((input) => input.addEventListener('change', calculate));
      const requestedPlan = new URLSearchParams(window.location.search).get('plan');
      const matchingPlan = planInputs.find((input) => input.dataset.plan === requestedPlan);
      if (matchingPlan) matchingPlan.checked = true;
      payNow.addEventListener('click', async () => {
        if (payNow.disabled || !payNow.dataset.variantId) return;
        payNow.disabled = true;
        checkoutStatus.textContent = payNow.dataset.loadingMessage;
        const properties = {
          'Measured turf': `${payNow.dataset.billedArea} sq. ft.`,
          'Service plan': payNow.dataset.planName,
          'Visit frequency': payNow.dataset.frequency,
          'Included visits': payNow.dataset.visits
        };
        if (payNow.dataset.minimumApplied === 'true') properties['Pricing basis'] = '$100 minimum service charge per visit';
        const items = [{
          id: Number(payNow.dataset.variantId),
          quantity: Number(payNow.dataset.units),
          properties
        }];
        if (payNow.dataset.includeWaste === 'true') {
          items.push({
            id: 53448253636917,
            quantity: Number(payNow.dataset.visits),
            properties: {
              'Service plan': payNow.dataset.planName,
              'Waste disposal': 'On-property disposal; waste remains in customer trash'
            }
          });
        }
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign('/checkout');
        } catch (error) {
          checkoutStatus.textContent = payNow.dataset.errorMessage;
          payNow.disabled = false;
        }
      });
      date.addEventListener('change', validateDate);

      /* tp-booking-draft-handoff: preserve estimate details when switching to pay-in-person booking. */
      const bookingDraftStorageKey = 'turfProBookingDraft';
      const saveBookingDraft = () => {
        try {
          const draft = {};
          new FormData(form).forEach((value, key) => {
            if (typeof value === 'string' && value.trim()) draft[key] = value;
          });
          draft.savedAt = new Date().toISOString();
          sessionStorage.setItem(bookingDraftStorageKey, JSON.stringify(draft));
        } catch (error) {
          console.warn('Turf Pro booking handoff could not be saved', error);
        }
      };
      form.addEventListener('input', saveBookingDraft);
      form.addEventListener('change', saveBookingDraft);
      form.querySelector('[data-tp-pay-in-person-link]')?.addEventListener('click', saveBookingDraft);

      form.addEventListener('submit', () => {
        calculate();
        validateDate();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeEstimator, { once: true });
    } else {
      initializeEstimator();
    }
    document.addEventListener('shopify:section:load', initializeEstimator);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["turf-pro-site-frame"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeHeaderTools = () => {
      const toggle = document.querySelector('[data-tp-menu-toggle]');
      const panel = document.getElementById('TurfProMenuPanel');
      const cartCount = document.getElementById('TurfProCartCount');
      if (!toggle || !panel || toggle.dataset.ready === 'true') return;
      toggle.dataset.ready = 'true';

      const closeMenu = () => {
        panel.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
      };
      const openMenu = () => {
        panel.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
      };

      toggle.addEventListener('click', () => {
        if (panel.hidden) openMenu(); else closeMenu();
      });
      panel.addEventListener('click', (event) => {
        if (event.target.closest('a')) closeMenu();
      });
      document.addEventListener('click', (event) => {
        if (!panel.hidden && !panel.contains(event.target) && !toggle.contains(event.target)) closeMenu();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeMenu();
      });

      const updateCartCount = async () => {
        if (!cartCount) return;
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(root + 'cart.js', {
            credentials: 'same-origin',
            headers: {Accept: 'application/json'}
          });
          if (!response.ok) return;
          const cart = await response.json();
          const count = Number(cart.item_count || 0);
          cartCount.textContent = count > 99 ? '99+' : String(count);
          cartCount.hidden = count === 0;
        } catch (error) {
          console.warn('Turf Pro cart count could not be updated', error);
        }
      };

      updateCartCount();
      ['cart:updated', 'cart:change'].forEach((eventName) => {
        document.addEventListener(eventName, updateCartCount);
      });
      document.addEventListener('shopify:section:load', updateCartCount);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeHeaderTools, {once: true});
    } else {
      initializeHeaderTools();
    }
    document.addEventListener('shopify:section:load', initializeHeaderTools);
  })();


  (() => {
    const initializeConcierge = () => {
      const concierge = document.getElementById('TurfProConcierge');
      if (!concierge || concierge.dataset.ready === 'true') return;
      concierge.dataset.ready = 'true';
      if (window.location.pathname.includes('/pages/book-turf-cleaning')) return;

      const storageKey = 'turfProConciergeDismissed';
      const wasDismissed = () => {
        try { return window.sessionStorage.getItem(storageKey) === 'true'; } catch (error) { return false; }
      };
      const rememberDismissal = () => {
        try { window.sessionStorage.setItem(storageKey, 'true'); } catch (error) {}
      };
      const closeButton = concierge.querySelector('.tp-concierge__close');
      let startX = null;

      const dismiss = (direction = 'right') => {
        rememberDismissal();
        concierge.classList.remove('is-visible');
        concierge.classList.add(direction === 'left' ? 'is-dismissing-left' : 'is-dismissing-right');
        window.setTimeout(() => { concierge.hidden = true; }, 240);
      };

      closeButton?.addEventListener('click', () => dismiss('right'));
      concierge.addEventListener('pointerdown', (event) => { startX = event.clientX; });
      concierge.addEventListener('pointerup', (event) => {
        if (startX === null) return;
        const distance = event.clientX - startX;
        startX = null;
        if (Math.abs(distance) >= 48) dismiss(distance < 0 ? 'left' : 'right');
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !concierge.hidden) dismiss('right');
      });

      if (wasDismissed()) return;
      window.setTimeout(() => {
        if (wasDismissed() || document.hidden) return;
        concierge.hidden = false;
        window.requestAnimationFrame(() => concierge.classList.add('is-visible'));
      }, 30000);
    };

    document.addEventListener('DOMContentLoaded', initializeConcierge);
    document.addEventListener('shopify:section:load', initializeConcierge);
    initializeConcierge();
  })();
  } catch(e) { console.error(e); }
})();

})();
